import { inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Operation } from '../models/subscription';
import { AppService } from '@app/app.service';
import { HttpClient } from '@angular/common/http';
import { AppConfigService as appConfig } from '@app/app.config';
import { OperationReverseMapperService } from '../mappers/operation-reverse-mapper';
import { QuotationRequest } from '../interfaces/financial-simulator/quotation-interface';
import { QuotationResponse } from '../interfaces/financial-simulator/quotation-response.interface';
import { QuotationReverseMapperService } from '../mappers/quotation-mapper-reverse';

@Injectable({
    providedIn: 'root',
})
export class LoadDataService {

    private appData = inject(AppService);
    private appConfig = inject(appConfig);
    private http = inject(HttpClient);
    private operationReverseMapperService = inject(OperationReverseMapperService);
    private quotationReverseMapperService = inject(QuotationReverseMapperService);

    savedData: Subject<any> = new Subject<any>();

    constructor() {
        this.savedData.subscribe((value) => {
            this.appData.data.userData = value;
        });
    }

    loadDataLocal(dataPage: any, pageStep: string) {
        console.log('1', dataPage);

        this.savedData.next(this.appData.data.userData);
    }

    loadOperation (token : string) {
        console.log('AppData', this.appData);

        this.getOrder(token).subscribe({
            next: (response) => {
                const operation = response;
                console.log("operation ", operation);
                this.appData.data = this.operationReverseMapperService.transform(operation);
                console.log("data ", this.appData.data);
            },
            error: (error) => console.log('error', error),
        });
    }

    getOrder(token: string): Observable<Operation> {
        const OPERATION_URL: string = this.appConfig.apiBffUrl.concat('/api/mobility/operation?token=').concat(token);
        //const OPERATION_URL: string = 'http://localhost:8080'.concat('/api/mobility/operation?token=').concat(token);

        return this.http.get<Operation>(OPERATION_URL);
    }

    loadConditions (quotationRequest : QuotationRequest) {
        console.log('Operacion', quotationRequest);

        this.getConditions(quotationRequest).subscribe({
            next: (response) => {
                const operation = response;
                console.log("operation ", operation);
                this.appData.data.financialData = this.quotationReverseMapperService.transform(operation);
                console.log("data ", this.appData.data);
            },
            error: (error) => console.log('error', error),
        });
    }

    getConditions(qr: QuotationRequest): Observable<QuotationResponse> {
		const CONDITIONS_URL: string = this.appConfig.apiBffUrl.concat('/api/mobility/quotations');
        //const CONDITIONS_URL: string = 'http://localhost:8080/api/mobility/quotations';

        return this.http.post<QuotationResponse>(CONDITIONS_URL, qr).pipe();
    }

}
